import {gql} from '@apollo/client'

export const CREATE_CONTACT_FILTER = gql`
  mutation createContactFilter($contactFilterData: contact_filter_input!) {
    createContactFilter(contactFilterData: $contactFilterData) {
      success
      errors {
        field
        message
      }
      contactFilter {
        id
        name
        filters
        updated
      }
    }
  }
`

export const UPDATE_CONTACT_FILTER = gql`
  mutation updateContactFilter($id: Int!, $contactFilterData: contact_filter_update_input!) {
    updateContactFilter(id: $id, contactFilterData: $contactFilterData) {
      success
      errors {
        field
        message
      }
      contactFilter {
        id
        name
        filters
        updated
      }
    }
  }
`

export const DELETE_CONTACT_FILTER = gql`
  mutation deleteContactFilter($id: Int!) {
    deleteContactFilter(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`
